<template>
  <div class="oido-color-selector" :class="{ disabled, readonly }">
    <label v-if="label">
      <span class="label-text" v-text="label"></span>
      <span class="required-marker" v-if="required"> *</span>
    </label>
    <div class="input-section">
      <div class="color-swatch" :style="{ backgroundColor: modelValue || 'transparent' }"
        @click="openPicker">
        <span v-if="!modelValue" class="no-color">?</span>
      </div>
      <input type="text" :value="modelValue" @input="onTextInput" :disabled="disabled"
        :readonly="readonly" placeholder="#000000" maxlength="7" />
      <input ref="nativePicker" type="color" class="native-picker" :value="modelValue || '#000000'"
        @input="onPickerInput" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: String,
    label: String,
    disabled: Boolean,
    readonly: Boolean,
    required: Boolean
  },
  emits: ['update:modelValue'],
  methods: {
    openPicker() {
      if (this.disabled || this.readonly) return;
      this.$refs.nativePicker.click();
    },
    onTextInput(event) {
      let value = event.target.value;
      if (value && !value.startsWith('#')) {
        value = '#' + value;
      }
      this.$emit('update:modelValue', value);
    },
    onPickerInput(event) {
      this.$emit('update:modelValue', event.target.value);
    }
  }
}
</script>

<style scoped>
.oido-color-selector {
  width: 100%;
  position: relative;
  margin-top: 0.7rem;
  padding-bottom: 0.8rem;
  font-size: 0.9rem;
}

label {
  font-weight: 590;
  margin-right: 1rem;
  display: flex;
  align-items: center;
  font-size: 0.9rem;
  color: #222;
  margin-bottom: 0.2rem;
}

.input-section {
  display: flex;
  align-items: center;
}

.color-swatch {
  width: 2.51rem;
  height: 2.51rem;
  border-radius: 0.3rem;
  border: 1px solid #ccc;
  cursor: pointer;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.disabled .color-swatch,
.readonly .color-swatch {
  cursor: default;
}

.no-color {
  color: #aaa;
  font-size: 0.8rem;
}

input[type="text"] {
  background-color: #F9FAFB !important;
  border: none !important;
  border-bottom: 1px solid var(--light-color) !important;
  padding: 0.3rem 0.45rem;
  min-height: 2.51rem;
  flex: 1;
  color: #343;
  font-family: monospace;
  font-size: 0.9rem;
  margin-left: 0.5rem;
}

.native-picker {
  position: absolute;
  width: 0;
  height: 0;
  overflow: hidden;
  opacity: 0;
  pointer-events: none;
}

.disabled input[type="text"] {
  background-color: rgba(0, 0, 0, 0.05) !important;
  color: #444;
}
</style>
